import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

//For ajax data
export const store = new Vuex.Store({
  state: {
    //env
    website: "application.cogir.net",
    recaptcha: "6Lft-TwbAAAAAFRQM4IMkbomegDIFml0Wo7P9Xl5",
    urls: {
      "home" : {json: "http://127.0.0.1:8087", formdata: "http://127.0.0.1:8088"}, 
      "staging" : {json: "https://staging.cogir.net:8088", formdata: "https://staging.cogir.net:8089", mssql: "https://staging.cogir.net:8088"},
      "prod" : {json: "https://application.cogir.net/ApplicationsConnect.php", formdata: "https://application.cogir.net/ApplicationsFormData.php", mssql: "https://application.cogir.net/ApplicationsConnect.php"}
    },
    user: null,
    statusMessage: "",
    processData: [],
    endorserData: [],
    buildings: [],
    applicantsType: [],
    activatedStatus: false,
    publicUnits: [],
    inclusions: [],
    otherServices : [],
    creditStatus: [],
    process: [],
    processEndorser: [],
    propectsUnits: [],
    noUnitAvailableFromQuery: null,
    prospectSession: []
  },
  getters: {
    getRecaptcha: state => {
      return state.recaptcha;
    },
    getWebsite: state => {
      return state.website;
    },
    getUrlsList: state => {
      return state.urls;
    },
    getUser: state => {
      return state.user;
    },
    getBuildings: state => {
      return state.buildings;
    },
    getStatus: state => {
      return state.statusMessage;
    },
    getProcessData: state => {
      return state.processData;
    },
    getApplicantsType: state => {
      return state.applicantsType;
    },
    getAccountActivatedStatus:state => {
      return state.activatedStatus;
    },
    getPublicUnits: state => {
      return state.publicUnits;
    },
    getInclusions: state => {
      return state.inclusions;
    },
    getOtherServices: state => {
      return state.otherServices;
    },
    getCreditStatus: state => {
      return state.creditStatus;
    },
    getProcess: state => {
      return state.process;
    },
    getProcessEndorser: state => {
      return state.processEndorser;
    },
    getEndorserData: state => {
      return state.endorserData;
    },
    getProspectsUnits: state => {
      return state.propectsUnits;
    },
    getNoUnitAvailableFromQuery: state => {
      return state.noUnitAvailableFromQuery;
    },
    getProspectSession: state => {
      return state.prospectSession;
    },
  },
  mutations: {
    addUser (state, val) {
      state.user = val;
    },
    addBuildings (state, val) {
      state.buildings = val;
    },
    addStatus (state, val) {
      state.statusMessage = val;
    },
    addProcessData (state, val) {
      state.processData = val;
    },
    addApplicantsType (state, val) {
      state.applicantsType = val;
    },
    setAccountActivatedStatus (state, val) {
      state.activatedStatus = val;
    },
    addPublicUnits(state, val) {
      state.publicUnits = val;
    },
    addInclusions(state, val) {
      state.inclusions = val;
    },
    addOtherServices(state, val) {
      state.otherServices = val;
    },
    addCreditStatus(state, val) {
      state.creditStatus = val;
    },
    addProcess(state, val) {
      state.process = val;
    },
    addEndorserData(state, val) {
      state.endorserData = val;
    },
    addProcessEndorser(state, val) {
      state.processEndorser = val;
    },
    addProspectsUnits(state, val) {
      state.propectsUnits = val;
    },
    addNoUnitAvailableFromQuery(state, val) {
      state.noUnitAvailableFromQuery = val;
    },
    addProspectSession(state, val) {
      state.prospectSession = val;
    }
  }
})
